import React, {Component} from 'react'
import User from "../../helpers/user";

export default class PricingData extends Component {
    constructor(props) {
        super()
        this.state = {
            balanceInfo: props.balanceInfo,
            profile: props.profile
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            balanceInfo: nextProps.balanceInfo,
            profile: nextProps.profile
        })
    }

    render() {
        if (!Object.keys(this.state.balanceInfo).length) return null
        return (
            <section id='personal-data'>
                <ul className='no-ul-style'>
                    {this.state.balanceInfo.showBalance ? <li><b> Rendelkezésre álló egyenleg: {this.state.balanceInfo.balance} Ft </b></li> : null}
                    {User.isTestMode() ? <li><b> Teszt üzemmód: {User.testModeExpiration()}</b></li> : null}
                    <li>
                        <hr/>
                    </li>
                    {User.hasModule('customer') ? <li><b> Vevő modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.customerUnitPrice} Ft</b></li> : null}
                    {User.hasModule('bank') ? <li><b>Bank modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.bankUnitPrice} Ft</b></li> : null}
                    {User.hasModule('supplier') ? <li><b>Szállító modulban</b> egy tétel kontírozásának egységára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.supplierUnitPrice} Ft</b></li> : null}
                    {User.hasModule('cashregister') ? <li><b>Pénztár modulban</b> egy pénztárgép egy havi adatainak kontírozásának ára (ár 27% ÁFÁ-t tartalmaz): <b>{this.state.balanceInfo.cashRegisterUnitPrice} Ft</b></li> : null}
                </ul>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/pricingdata.js